import { useEffect } from "react";
import { useUnleashClient } from "@unleash/proxy-client-react";
import { subscribeFeatureFlagsSync } from "@/lib/refresh-feature-flags";

/** Sincroniza toggles do Unleash entre abas quando uma flag é alterada no backoffice. */
export function useFeatureFlagsSync() {
  const client = useUnleashClient();

  useEffect(() => subscribeFeatureFlagsSync(client), [client]);
}
